import { apiInstance } from "shared/api";
import { AttachResponse, PayoutResponse, PayoutBody } from "./types";

export const payout = (
  id: string,
  body?: PayoutBody,
): Promise<PayoutResponse> => {
  return apiInstance
    .post(`/v1/payout/${id}`, body)
    .then((response) => response.data);
};

export const attachCard = (): Promise<AttachResponse> => {
  return apiInstance.get(`/v1/cards/attach`).then((response) => response.data);
};
export const syncCard = (): Promise<PayoutResponse> => {
  return apiInstance.post(`/v1/cards/sync`).then((response) => response.data);
};
